const Footer = () => {
	return (
        <div style={{height: '300px'}} />
    );
}

export default Footer;